import gql from "graphql-tag";
import { useContext } from "react";
import { useQuery } from "react-apollo";

import { CityContext } from "../context/CityContext";
import {
  getReviewsShops,
  getReviewsShopsVariables,
} from "../../__generated__/getReviewsShops";

const GET_REVIEWS_SHOPS = gql`
  query getReviewsShops($where: ShopWhereInput!) {
    reviewsShops(where: $where) {
      id
      name
    }
  }
`;

const useReviewsShops = () => {
  const { domain } = useContext(CityContext);

  const { loading, error, data } = useQuery<
    getReviewsShops,
    getReviewsShopsVariables
  >(GET_REVIEWS_SHOPS, {
    variables: {
      where: {
        primaryDomain: { host: domain },
      },
    },
  });

  return { data, loading, error };
};

export default useReviewsShops;
